import Image1 from "../../assets/testimonial1.png";
import Image2 from "../../assets/testimonial2.png";
import Image3 from "../../assets/testimonial3.png";

export const Data = [
    {
        id: 1,
        image: Image1,
        name: "Mehedi Hasan Rabby",
        description: "Wakil is one of the most dedicated Shopify developers I've worked with. He independently architected and shipped complex apps — from discount logic engines to Checkout Extensibility and POS integrations — with minimal hand-holding. His deep understanding of the Shopify ecosystem makes him a genuine asset to any product team."
    },
    {
        id: 2,
        image: Image2,
        name: "Shahinoor Sumon",
        description: "We brought Wakil on to build our telemedicine platform from the ground up, and he delivered beyond expectations. He built a reliable system for patient-doctor communication, appointment scheduling, and in-app reminders — all on time and well-documented. His communication throughout was excellent."
    },
    {
        id: 3,
        image: Image3,
        name: "Arif Rahman",
        description: "Working alongside Wakil at BZM Graphics was a great experience. He took full ownership of our HRM application and image-processing tools, writing clean, maintainable code while managing AWS deployments and CI/CD pipelines. He's the kind of engineer who makes the whole team better."
    },
];
